import useCustomTranslation from 'hooks/useCustomTranslation'
import { StyledCheckbox, Subtext } from 'pages/InfoRequestPage.styles'
import { ComponentInterface, SFDDLProps } from 'typings'

// eslint-disable-next-line @typescript-eslint/no-namespace
declare namespace window {
  // eslint-disable-next-line no-underscore-dangle, @typescript-eslint/naming-convention
  const _SFDDL: SFDDLProps
}

const setRequestTypeAnalytics = (value: string, checked: boolean) => {
  // eslint-disable-next-line no-undef, @typescript-eslint/naming-convention, no-underscore-dangle
  const { RequestType: requestType } = window._SFDDL.requestcheckboxInfo
  let values = requestType ? requestType.split('|') : []
  if (checked) {
    values.push(value)
  } else {
    values = values.filter(item => item !== value)
  }
  // eslint-disable-next-line no-undef, @typescript-eslint/naming-convention, no-underscore-dangle
  window._SFDDL.requestcheckboxInfo.RequestType = values.join('|')
}

const WashingtonOptions = ({
  formValues,
  handleOnChange
}: ComponentInterface): JSX.Element => {
  const t = useCustomTranslation('form')

  // eslint-disable-next-line sonarjs/no-duplicate-string
  const rightTo = t('request.rightTo')

  return (
    <>
      <StyledCheckbox
        id="accessPersonalInfo"
        isChecked={formValues.accessPersonalInfo}
        onChange={() => {
          const checked = !formValues.accessPersonalInfo
          handleOnChange('accessPersonalInfo', checked)
          setRequestTypeAnalytics('AccessPI', checked)
        }}
        data-testid="access-personal-info"
        data-reason="righttoaccesspersonalinformation"
        data-type="Checkbox"
        className="ensightencustomevent"
        isDisabled={formValues.rightToAppeal}
      >
        {rightTo + t('request.access')}
      </StyledCheckbox>
      <StyledCheckbox
        id="erasurePersonalInfo"
        isChecked={formValues.erasurePersonalInfo}
        onChange={() => {
          const checked = !formValues.erasurePersonalInfo
          handleOnChange('erasurePersonalInfo', checked)
          setRequestTypeAnalytics('ErasurePI', checked)
        }}
        data-testid="erasure-personal-info"
        data-reason="righttoerasurepersonalinformation"
        data-type="Checkbox"
        className="ensightencustomevent"
        isDisabled={formValues.rightToAppeal}
      >
        {rightTo + t('request.erasure')}
      </StyledCheckbox>
      <Subtext className="subtext-up">{t('request.erasureSubtext')}</Subtext>
      <StyledCheckbox
        id="rightToRevokeConsent"
        isChecked={formValues.rightToRevokeConsent}
        onChange={() => {
          const checked = !formValues.rightToRevokeConsent
          handleOnChange('rightToRevokeConsent', checked)
          setRequestTypeAnalytics('rightToRevokeConsent', checked)
        }}
        data-testid="revoke-consent"
        data-reason="rightToRevokeConsent"
        data-type="Checkbox"
        className="ensightencustomevent"
        isDisabled={formValues.rightToAppeal}
      >
        {rightTo + t('request.revokeConsent')}
      </StyledCheckbox>
      <StyledCheckbox
        id="rightToAppeal"
        isChecked={formValues.rightToAppeal}
        onChange={() => {
          const checked = !formValues.rightToAppeal
          handleOnChange('rightToAppeal', checked)
          setRequestTypeAnalytics('rightToAppeal', checked)
        }}
        data-testid="right-to-appeal"
        data-reason="rightToAppeal"
        data-type="Checkbox"
        className="ensightencustomevent"
        isDisabled={
          formValues.accessPersonalInfo ||
          formValues.erasurePersonalInfo ||
          formValues.rightToRevokeConsent
        }
      >
        {rightTo + t('request.appeal')}
      </StyledCheckbox>
    </>
  )
}

export default WashingtonOptions
